<template>
	<div class="task-component">
		<table-pagination
			v-loading="loading"
		    pagination
		    :data="list"
		    :column="column"
		    :total="total"
		    :page.sync="listQuery.pageNumber"
		    :limit.sync="listQuery.pageSize"
		    @pagination="getList"/>
	</div>
</template>

<script>
	export default {
		props:['customerId'],
		data() {
			return {
				loading:false,
				total:1,
				listQuery: {
					pageNumber:1,
					pageSize:10,
					brandIdentify:'',
					phoneNumber:''
				},
				list:[],
				column:[
					{
					    label: '序号',
					    width: 150,
					    render: (h, scope) => {
					        return <span>{((this.listQuery.pageNumber - 1) * this.listQuery.pageSize) + (scope.$index + 1)}</span>
					    }
					},
					{ label: '外呼主题', prop: 'subjectName' },
					{ label: '外呼问卷', prop: 'paperName' },
					{ label: '任务备注', prop: 'taskRemarks' },
					{
						label: '是否完成',
						 prop: 'isFinish' ,
						 render:(h,scope) => {return <span>{scope.row.isFinish == 0 ? '否' : '是'}</span>}
					},
					{ label: '上一次外呼时间', prop: 'lastObTime' },
					{
						label: '任务状态',
						 prop: 'taskStatus' ,
						 render:(h,scope) => {
							 return <span>{scope.row.taskStatusName}</span>
						 }
					},
					{ label: '客户名称', prop: 'custName' },
					{ label: '执行坐席', prop: 'userNickname' },
					{
					    label: '操作',
					    prop: 'cation',
					    align: 'center',
					    width: 180,
					    fixed: 'right',
					    render: (h, scope) => {
							return (
								<div>
									<el-link onClick={() => this.handleDetail(scope.row)} underline={false} type="primary">查看详情</el-link>
								</div>
							)
					    }
					}
				]
				
			}
		},
		methods: {
			handleDetail(row){
				this.$router.push({
					path:`/breathe/callOut/info/${row.taskId}?type=details`
				})
			},
			async getPhone() {
				await this.$api.apiPostCustomerInfo({
					brand: this.$store.getters.userInfo.brandIdentify,
					customerId: this.customerId}).then(res => {
						if(res.errcode != 0) return;
						this.listQuery.phoneNumber = res.data?.[0]?.phoneNumber;
						if(this.listQuery.phoneNumber){
							this.getList()
						}
				})
			},
			async getList(){
				this.listQuery.brandIdentify = this.$store.getters.userInfo.brandIdentify;
				await this.$api.getBreathTaskList(this.listQuery).then(response => {
					this.loading = false;
					if(response.errcode != 0) return;
					this.list = response.data;
					this.total = parseInt(response.total);
				}).catch(err => {
					this.loading = false;
				})
			}
		},
		mounted(){
			this.getPhone()
		}
	}
</script>

<style>
</style>
